import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';

export class Notification extends Mappeable {

    idTypeAlarmPk: number;
    txtTypeAlarm: string;
    //periodNotification: any;
    typeCategoryAlarm: any;
    mrkActive: boolean;
    isComunicationMail: number;

    constructor(o) {
        super(o);
        this.mrkActive = this.mrkActive ??  false 
    }

    public mapToBack() {
        return {
            txtTypeAlarm: this.txtTypeAlarm,
            typeCategoryAlarm: this.typeCategoryAlarm,
            mrkActive: this.mrkActive,
            isComunicationMail: 1
        }
    }

}